// What the OS media controls (lock screen, notification, car display) show.
//
// Every field is derived from scratch on each call and the shape is always
// complete — a field with nothing behind it is explicitly undefined. That's
// deliberate: these get spread over the existing metadata, so a key we left out
// would keep the *previous* item's value and strand, say, a finished song's
// artist beside the next show's title.
//
// The flip side is that coming up empty blanks the card mid-playback, so each
// field falls back through everything we know rather than dead-ending on the
// item type alone. A station we're playing always has a call sign, so there is
// always something to show.
export default function nowPlayingMetadata(metadata) {
  let track = metadata.itemType === 'track' ? metadata.track : undefined;
  let stationName = metadata.station?.callSign;
  let showName =
    metadata.airing?.showTitle || metadata.show?.title || metadata.airing?.title;

  let title = track?.title || showName || stationName;

  // The station stands in as the "artist" when no song is playing, so the second
  // line isn't blank — but not when it's already the title (an unscheduled block
  // with nothing but a station to name).
  let artist =
    track?.artistName || (title === stationName ? undefined : stationName);

  return {
    title,
    artist,
    album: track?.releaseName,
    artwork: artworkFor(metadata.imageSource),
  };
}

function artworkFor(imageSource) {
  if (!imageSource) {
    return undefined;
  }

  let artwork = [
    imageSource.small_square?.url && {
      src: imageSource.small_square.url,
      sizes: '250x250',
    },
    imageSource.medium_square?.url && {
      src: imageSource.medium_square.url,
      sizes: '500x500',
    },
    imageSource.large_square?.url && {
      src: imageSource.large_square.url,
      sizes: '1500x1500',
    },
  ].filter(Boolean);

  return artwork.length > 0 ? artwork : undefined;
}
